import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {UnitTypeToTextPipe} from "../../../pipes/unit-type-to-text.pipe";
import {RegularRentRangeComponent} from "../../regular-rent-range/regular-rent-range.component";
import {RegularUnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {unitTypes} from "../../../model/unit-type";
import {FilterByUnitTypePipe} from "../../../pipes/filter-by-unit-type.pipe";

@Component({
  selector: 'homey-regular-eligible-units',
  standalone: true,
  imports: [
    UnitTypeToTextPipe,
    RegularRentRangeComponent,
    FilterByUnitTypePipe
  ],
  templateUrl: './regular-eligible-units.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegularEligibleUnitsComponent {
  public readonly eligibleUnits = input.required<RegularUnitAdvertisementDto[]>();
  protected readonly unitTypes = unitTypes;
}
